import {
  getProductsForCheckout,
  TGetProductsForCheckoutQuery,
} from '@commenda/api';
import { TBillingProductForCheckout } from '@commenda/types/src/billing/types';
import { useEffect, useState } from 'react';

export const useGetProductsForCheckout = (
  query: TGetProductsForCheckoutQuery
) => {
  const [productsToCheckout, setProductsToCheckout] = useState<
    TBillingProductForCheckout[] | null
  >(null);
  const fetchProductsForCheckout = async () => {
    const billingItemsForCheckoutRes = await getProductsForCheckout(query);
    if (!billingItemsForCheckoutRes?.ok) {
      console.error('Failed to fetch products for checkout');
      return;
    }
    const billingItemsForCheckout = await billingItemsForCheckoutRes.json();
    setProductsToCheckout(billingItemsForCheckout);
  };

  useEffect(() => {
    fetchProductsForCheckout();
  }, [JSON.stringify(query)]);

  return { productsToCheckout };
};
